export default __webpack_public_path__ + "static/media/hero_second.a827fe98.jpg";